export default {
  title: 'TIME DELAY SETTINGS',
  items: {
    ProviderRatingDelay: {
      label: 'Provider Rating Delay',
      type: 'integer',
      unit: 'seconds'
    },
    TipRatingDelay: {
      label: 'Tip Rating Delay',
      type: 'integer',
      unit: 'seconds'
    },
    HereMapsRouteDelay: {
      label: 'HERE maps Route delay',
      type: 'integer',
      unit: 'seconds'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/time-delay-settings.js